import { computed, watch, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useJourneysStore } from '@/core/collections/journeys/journeys.store';
import { getJourneys } from '@/core/collections/journeys/journeys.service';

export const useJourneys = (draftData: Ref<any | null>) => {
   const { locale } = useI18n();
   const journeysStore = useJourneysStore();
   const { journeyData } = storeToRefs(journeysStore);

   const journeyOptions = computed(() => journeysStore.getJourneyOptions(locale.value));
   const teamOptions = computed(() => journeysStore.getTeamOptionsByJourney(draftData.value?.journey_id));

   onMounted(async () => {
      const journeysResponse = await getJourneys();
      journeysStore.setJourneys(journeysResponse);
   });

   // When journey changes, always reset team
   watch(
      () => draftData.value?.journey_id,
      () => {
         const data = draftData.value;
         if (!data) return;
         data.journey_team_id = null;
      },
   );

   // When spontaneous application is toggled off, clear team and journey
   watch(
      () => draftData.value?.show_spontaneous_application,
      (enabled) => {
         if (!enabled) {
            const data = draftData.value;
            if (!data) return;
            data.journey_id = null;
            data.journey_team_id = null;
         }
      },
   );

   return {
      teamOptions,
      journeyOptions,
      journeyData,
   };
};
